import React from 'react';
import classNames from 'classnames';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MultiSelect, MultiSelectProps } from './MultiSelect';
import { SingleSelect, SingleSelectProps } from './SingleSelect';
import { SelectOptionType } from './types';
import { useThemeVarsClass } from '../../../theme/provider';

import cn from './styles.module.scss';

export type SelectProps<
  ValueType = any,
  OptionType extends SelectOptionType = SelectOptionType,
> = MultiSelectProps<ValueType[], OptionType> | SingleSelectProps<ValueType, OptionType>;

export function Select<
  ValueType = any,
  OptionType extends SelectOptionType = SelectOptionType,
>(props: SelectProps<ValueType, OptionType>) {
  const {
    className,
    label,
    error,
    ...restProps
  } = props;
  const themeClassName = useThemeVarsClass();

  return (
    <div
      className={classNames(
        cn.select,
        themeClassName,
        className,
        {
          [cn.error]: !!error,
        },
      )}
    >
      {label && (
        <label htmlFor={restProps.name} className={cn.label}>{label}</label>
      )}
      {restProps.multiple
        ? <MultiSelect {...restProps} />
        : <SingleSelect {...restProps} />
      }
      {!!error && (
        <div className={cn.errorContainer}>
          <ExclamationCircleFilled className={cn.icon} />
          {error}
        </div>
      )}
    </div>
  );
}
